import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function PurchaseReturnReport(props) {
    const urlParams = new URLSearchParams(window.location.search);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [addedby, setAddedby] = useState({username: ''});
    const [mode, setMode] = useState({mode: ''});
    const [rows, setRows] = useState([]);
    const [userData, setUserData] = useState([]);
    const [combinedData, setcombinedData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setEndDate(localDate);
    };
    const handleUser = (event) => {
        setAddedby({
            ...addedby,
            username: event.target.value
        });
    };
    const handleMode = (event) => {
        setMode({
            ...mode,
            mode: event.target.value
        });
    };
    useEffect(() => {
        try {
            axios.get(`${baseUrl}user-search/`)
                .then(function (response) {
                    setUserData(response.data);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        fetchData();
    }, [startDate, endDate, addedby, mode]);
    useEffect(() => {
        if (combinedData.length > 0) {
            setRows(combinedData);
        }
    }, [combinedData]);
    function fetchData() {
        setIsLoading(true);
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
        const url = `${baseUrl}purchase-return-report/?start_date=${startDateString}&end_date=${endDateString}&addedby=${addedby.username}&mode=${mode.mode}&status=1`;
        axios.get(url)
            .then(response => {
                setcombinedData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const columns = [
        {field: 'add_date_date', headerName: 'Date', width: 120},
        {field: 'grn_id', headerName: 'GRN ID', width: 80},
        {field: 'return_type', headerName: 'Return Type', width: 110},
        {
            field: 'return_no', headerName: 'Return Receipt',
            renderCell: (params) => (
                <Link to={`/purchase-return-invoice/${params.row.return_no}`} target="_blank">
                    {params.row.return_no}
                </Link>
            ),
            width: 120
        },
        {field: 'total', headerName: 'Return Amount', width: 150},
        {field: 'addedby', headerName: 'Cashier', width: 100},
    ];
    const getTotal = (rows, field) => {
        return rows.reduce((totals, row) => {
            const value = parseFloat(row[field]);
            if (!isNaN(value)) {
                return totals + value;
            }
            return totals;
        }, 0);
    };
    const Footer = ({rows}) => {
        const totalInvoicedAmount = getTotal(rows, 'total');
        return (
            <div style={{display: 'flex', justifyContent: 'space-evenly', padding: '8px'}}>
                <div>Total</div>
                <div>{totalInvoicedAmount?.toFixed(2)}</div>
            </div>
        );
    };
    const today = new Date();
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-calendar-days"
                aria-hidden="true" style={{color: 'red'}}></i> Purchase Return Report</h3>
            <div className="row">
                <div className="col-md-4">
                    <label className="control-label">Select Date</label>
                    <DatePicker
                        selected={startDate}
                        onChange={handleStartDateChange}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        placeholderText={'Please select From date'}
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showYearDropdown
                    />
                    <DatePicker
                        selected={endDate}
                        onChange={handleEndDateChange}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        maxDate={today}
                        placeholderText={'Please select To date'}
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showYearDropdown
                    />
                </div>

                <div className="col-md-4">
                    <div className="mb-4 mt-4 form-control">
                        <label htmlFor="user" className="form-label">Search by Cashier</label>
                        <select name="user" id="username" value={addedby.user} className="form-control"
                                onChange={(event) => handleUser(event)}>
                            <option value="">Select Cashier</option>
                            {userData.map((User, index) => (
                                <option key={index} value={User.username}>{User.username}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="mb-4 mt-4 form-control">
                        <label htmlFor="mode" className="form-label">Search by Sales Mode</label>
                        <select name="mode" id="mode" value={mode.mode} className="form-control"
                                onChange={(event) => handleMode(event)}>
                            <option value="">Select Return Mode</option>
                            <option value="Cash">Cash</option>
                            <option value="Cashless">Cashless</option>
                            <option value="internal">Internal Return</option>
                        </select>
                    </div>
                </div>
            </div>

            {!isLoading && combinedData.length > 0 ? (
                <div style={{height: "100%", width: "100%"}}>
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              rows={rows}
                              columns={columns}
                              pageSize={10}
                              slots={{
                                  toolbar: GridToolbar,
                                  footer: () => <Footer rows={rows}/>,
                              }}
                              autoHeight
                    />
                </div>
            ) : (
                <></>
            )}
        </section>
    )
}
export default PurchaseReturnReport;
